import ReactDataSheet from 'react-datasheet';

export interface Cell extends ReactDataSheet.Cell<Cell, string> {
    value: number | null | string;
    meta?: any;
}

export class IDataSheet extends ReactDataSheet<Cell, string> { }

